module.exports = __webpack_public_path__ + "media/assets/images/common/facebook-400b26e4871fed3f186d4ff5eb41aa6a.png";